import i18n from '@/i18n';
import axios from 'axios';
import normalizeBaseDomain from './normalizeBaseDomain';

const baseDomain = normalizeBaseDomain(process.env.VUE_APP_SCRUMBLE_API_URL);

const request = axios.create({
  baseURL: `${baseDomain}/api/v1`,
});

request.interceptors.request.use(
  (config) => {
    config.headers['Accept-Language'] = i18n.global.locale.value;
    return config;
  },
  (error) => Promise.reject(error)
);

export default request;
